import { useCallback } from 'react'

const useLoadComponentSpecs = () => {
  const loadComponentSpecs = useCallback(async (forceRefresh: boolean = true) => {
    const loadComponentSpecsPromise = new Promise((resolve, reject) => {
      window.AccountHelper.loadComponentSpecs(resolve, forceRefresh)
    })
    await loadComponentSpecsPromise
    return true
  }, [])
  return loadComponentSpecs
}

export default useLoadComponentSpecs
